var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ marginLeft: '0'})},[_c('div',{staticStyle:{"font-size":"large","font-weight":"bold","zIndex":"1"}},[_vm._v("\n    .\n  ")]),_c('iframe',{style:({ marginTop: '-200px',zIndex:0}),attrs:{"width":"100%","height":"1200","seamless":"","frameBorder":"0","scrolling":"no","src":_vm.agvReceiptDetails}})])
}
var staticRenderFns = []

export { render, staticRenderFns }